/**
 * @summary Takes a number and rounds it to the neares specified decimal 
    @example roundNumberToDecimalPlaces(27.738, 2) --> 27.74 
    @example roundNumberToDecimalPlaces(27.738, 1) --> 27.8
 */
export function roundNumberToDecimalPlaces(number: number, numberOfDecimalPlacesToRoundTo: number) {
    const factor = Math.pow(10, numberOfDecimalPlacesToRoundTo);

    return Math.round(number * factor) / factor;
}